import { Box } from '@material-ui/core';
import { SGSCard, SGSTableBack, SGSTooltip } from 'components';
import React, { useMemo, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { arretTravail } from '../../../core/services';
import { Cell, ColumnInterface, Row } from 'react-table';
import styles from '../../Affiliations/Affiliates/Affiliates.module.scss';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import SGSDrawer from 'components/SGSDrawer';
import { Arret } from 'core/models';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {};

const Arrets: React.FC<Props> = () => {
    const { t } = useTranslation();
    const [arret, setArret] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const [drawerOpened, setDrawerOpened] = useState(false);
    const [selectedArret, setselectedArret] = useState<Arret>();

    const toggleDrawer = (open: boolean) => {
        setDrawerOpened(open);
    };

    const handleDetails = (row: Row<Arret>) => {
        setselectedArret(row.original);
        toggleDrawer(true);
    };

    const columns = useMemo<ColumnInterface<Arret>[]>(
        () => [
            {
                Header: '',
                accessor: 'none',
                className: 'p-0 align-items-stretch',
                minWidth: 45,
                maxWidth: 45,
                disableFilters: true,
                disableSortBy: true,
                Cell: ({ row }: Cell<Arret>) => {
                    return (
                        <div className={styles.actions}>
                            <SGSTooltip title={<Box>{t('details')}</Box>}>
                                <div className={styles.actions__menu} onClick={() => handleDetails(row)}>
                                    <FontAwesomeIcon icon={faEllipsisV} size="lg" />
                                </div>
                            </SGSTooltip>
                        </div>
                    );
                },
            },
            {
                Header: 'Traitement',
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell} font-weight-bold`,
                accessor: (row: Arret) => (row.status === true ? `Traité` : 'En cours'),
                minWidth: 250,
                disableFilters: true,
                Cell: ({ value }: Cell<Arret>) => (
                    <SGSTooltip className="text-center" title="test">
                        {value}
                    </SGSTooltip>
                ),
            },
            {
                Header: 'Assuré status',
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell} font-weight-bold`,
                accessor: (row: Arret) =>
                    JSON.parse(row.form_data).assure_victime_pro_quali !== ''
                        ? `${JSON.parse(row.form_data).assure_victime_pro_quali} `
                        : 'Inconnu',
                minWidth: 250,
                disableFilters: true,
                Cell: ({ value }: Cell<Arret>) => (
                    <SGSTooltip className="text-center" title="test">
                        {value}
                    </SGSTooltip>
                ),
            },
            {
                Header: 'Arret dernier J/T',
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell} font-weight-bold`,
                accessor: (row: Arret) =>
                    JSON.parse(row.form_data).renseignements_ed_date_dernier_jour_t !== ''
                        ? `${JSON.parse(row.form_data).renseignements_ed_date_dernier_jour_t} `
                        : 'Inconnu',
                minWidth: 250,
                disableFilters: true,
                Cell: ({ value }: Cell<Arret>) => (
                    <SGSTooltip className="text-center" title="test">
                        {value}
                    </SGSTooltip>
                ),
            },

            {
                Header: 'Arret prescrit du ',
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell} font-weight-bold`,
                accessor: (row: Arret) =>
                    JSON.parse(row.form_data).renseignements_at_date_dernier_jour_t !== ''
                        ? `${JSON.parse(row.form_data).renseignements_at_date_dernier_jour_t} `
                        : 'Inconnu',
                minWidth: 250,
                disableFilters: true,
                Cell: ({ value }: Cell<Arret>) => (
                    <SGSTooltip className="text-center" title="test">
                        {value}
                    </SGSTooltip>
                ),
            },

            {
                Header: 'Arret prescrit au ',
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell} font-weight-bold`,
                accessor: (row: Arret) =>
                    JSON.parse(row.form_data).renseignements_at_date_reprise_t !== ''
                        ? `${JSON.parse(row.form_data).renseignements_at_date_reprise_t} `
                        : 'Inconnu',
                minWidth: 250,
                disableFilters: true,
                Cell: ({ value }: Cell<Arret>) => (
                    <SGSTooltip className="text-center" title="test">
                        {value}
                    </SGSTooltip>
                ),
            },

            {
                Header: 'Reprise',
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell} font-weight-bold`,
                accessor: (row: Arret) =>
                    JSON.parse(row.form_data).renseignements_at_motif_t_non_repris !== ''
                        ? `${JSON.parse(row.form_data).renseignements_at_motif_t_non_repris} `
                        : 'Inconnu',
                minWidth: 250,
                disableFilters: true,
                Cell: ({ value }: Cell<Arret>) => (
                    <SGSTooltip className="text-center" title="test">
                        {value}
                    </SGSTooltip>
                ),
            },

            {
                Header: 'Date',
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell} font-weight-bold`,
                accessor: (row: Arret) =>
                    JSON.parse(row.form_data).signature_date !== ''
                        ? `${JSON.parse(row.form_data).signature_date} `
                        : 'Inconnu',
                minWidth: 250,
                disableFilters: true,
                Cell: ({ value }: Cell<Arret>) => (
                    <SGSTooltip className="text-center" title="test">
                        {value}
                    </SGSTooltip>
                ),
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [t],
    );

    const getAffiliates = useCallback(({ pageIndex, pageLimit }) => {
        setLoading(true);
        arretTravail
            .getArretTravail(pageIndex, pageLimit)
            .then((response: any) => {
                setArret(response.data);
                setTotalPages(response.totalPage);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <Box>
            <SGSCard color="default" className="w-100">
                <SGSTableBack
                    columns={columns}
                    data={arret}
                    loading={loading}
                    fetchData={getAffiliates}
                    pageCount={totalPages}
                ></SGSTableBack>
            </SGSCard>
            <SGSDrawer open={drawerOpened} toggleDrawer={toggleDrawer}>
                <h1>Informations contractuelle </h1>
                <Box className={styles.summary}>
                    {selectedArret && (
                        <Box>
                            <Box>
                                {'ss :'}
                                {JSON.parse(selectedArret.form_data).ss_concerne
                                    ? JSON.parse(selectedArret.form_data).ss_concerne
                                    : 'undefined'}
                            </Box>
                            <Box>
                                {'Type de déclaration :'}

                                {JSON.parse(selectedArret.form_data).type_declaration
                                    ? JSON.parse(selectedArret.form_data).type_declaration
                                    : 'undefined'}
                            </Box>
                            <Box>
                                {'Déclaration Rectificative :'}
                                {JSON.parse(selectedArret.form_data).declaration_rectificative
                                    ? JSON.parse(selectedArret.form_data).declaration_rectificative
                                    : 'undefined'}
                            </Box>
                            <Box>
                                {'Raison sociale employeur : '}
                                {JSON.parse(selectedArret.form_data).employeur_rs
                                    ? JSON.parse(selectedArret.form_data).employeur_rs
                                    : 'undefined'}
                            </Box>
                            <Box>
                                {'Employeur nom :'}
                                {JSON.parse(selectedArret.form_data).employeur_nickname
                                    ? JSON.parse(selectedArret.form_data).employeur_nickname
                                    : 'undefined'}
                            </Box>
                            <Box>
                                {'Assuré nom :'}
                                {JSON.parse(selectedArret.form_data).assure_victime_nickname
                                    ? JSON.parse(selectedArret.form_data).assure_victime_nickname
                                    : 'undefined'}
                            </Box>
                            <Box>
                                {'Assurée Matricule : '}
                                {JSON.parse(selectedArret.form_data).assure_victime_serial_number
                                    ? JSON.parse(selectedArret.form_data).assure_victime_serial_number
                                    : 'undefined'}
                            </Box>
                            <Box>
                                {'SS Assuré :'}
                                {JSON.parse(selectedArret.form_data).assure_victime_ss
                                    ? JSON.parse(selectedArret.form_data).assure_victime_ss
                                    : 'undefined'}
                            </Box>
                            <Box>
                                {'Signataire : '}
                                {JSON.parse(selectedArret.form_data).signature_nom
                                    ? JSON.parse(selectedArret.form_data).signature_nom
                                    : 'undefined'}
                            </Box>
                        </Box>
                    )}
                </Box>
            </SGSDrawer>
        </Box>
    );
};

export default Arrets;
